// src/components/dashboard/client/MultiDashboardClient.js - PAGE DE SÉLECTION MULTI-PROJETS CORRIGÉE
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../../../firebase/config';
import { useAuth } from '../../../context/AuthContext';

const MultiDashboardClient = () => {
  const navigate = useNavigate();
  const { user, logout } = useAuth(); // CORRIGÉ: user au lieu de currentUser
  
  // États
  const [loading, setLoading] = useState(true);
  const [userProjects, setUserProjects] = useState([]);

  // Fonction de déconnexion
  const handleLogout = async () => {
    try {
      await logout();
      navigate('/login');
    } catch (error) {
      console.error('Erreur lors de la déconnexion:', error);
    }
  };

  // Charger tous les projets de l'utilisateur
  useEffect(() => {
    const loadUserProjects = async () => {
      if (!user) { // CORRIGÉ: user au lieu de currentUser
        console.log("❌ MULTI-DASHBOARD: Pas d'utilisateur connecté");
        navigate('/login');
        return;
      }
      
      try {
        console.log("🔍 MULTI-DASHBOARD: Chargement des projets de l'utilisateur:", user.uid);
        
        // Récupérer les informations utilisateur
        const userDoc = await getDoc(doc(db, "users", user.uid));
        
        if (userDoc.exists()) {
          const userData = userDoc.data();
          console.log("📊 MULTI-DASHBOARD: Données utilisateur:", userData);
          
          // Construire la liste des dossiers
          let dossierIds = [];
          
          if (userData.dossierIds && Array.isArray(userData.dossierIds)) {
            dossierIds = userData.dossierIds;
            console.log("✅ MULTI-DASHBOARD: Utilisation du nouveau système dossierIds");
          } else if (userData.dossierId) {
            dossierIds = [userData.dossierId];
            console.log("🔄 MULTI-DASHBOARD: Utilisation de l'ancien système dossierId");
          }
          
          console.log("📂 MULTI-DASHBOARD: dossierIds trouvés:", dossierIds);
          
          // Si un seul projet, rediriger vers le dashboard normal
          if (dossierIds.length === 1) {
            console.log("🔄 MULTI-DASHBOARD: Un seul projet, redirection vers dashboard normal");
            navigate(`/client/${dossierIds[0]}`, { replace: true });
            return;
          }
          
          // Si pas de projet, rediriger ou afficher message
          if (dossierIds.length === 0) {
            console.log("❌ MULTI-DASHBOARD: Aucun projet trouvé");
            setUserProjects([]);
            setLoading(false);
            return;
          }
          
          // Charger tous les projets
          console.log("🔄 MULTI-DASHBOARD: Chargement de", dossierIds.length, "projet(s)...");
          const projectPromises = dossierIds.map(async (id) => {
            console.log("📥 MULTI-DASHBOARD: Chargement projet", id);
            const projectDoc = await getDoc(doc(db, "dossiers", id));
            return projectDoc;
          });
          
          const projectDocs = await Promise.all(projectPromises);
          
          const projects = projectDocs
            .filter(doc => {
              console.log("📄 MULTI-DASHBOARD: Projet", doc.id, "existe:", doc.exists());
              return doc.exists();
            })
            .map(doc => {
              const data = { id: doc.id, ...doc.data() };
              console.log("📋 MULTI-DASHBOARD: Projet chargé:", data);
              return data;
            })
            .sort((a, b) => (b.createdAt?.toDate?.() || new Date()) - (a.createdAt?.toDate?.() || new Date()));
          
          setUserProjects(projects);
          console.log("✅ MULTI-DASHBOARD:", projects.length, "projet(s) chargé(s)");
          
        } else {
          console.log("❌ MULTI-DASHBOARD: Document utilisateur non trouvé");
          navigate('/login');
          return;
        }
      } catch (error) {
        console.error("❌ MULTI-DASHBOARD: Erreur lors du chargement des projets:", error);
      }
      
      setLoading(false);
    };

    loadUserProjects();
  }, [user, navigate]); // CORRIGÉ: user au lieu de currentUser

  // Fonction pour générer le nom d'affichage intelligent
  const getProjectDisplayName = (project, index) => {
    const sameCityProjects = userProjects.filter(p => 
      p.adresseClient?.split(',')[0]?.trim() === project.adresseClient?.split(',')[0]?.trim()
    );
    
    if (sameCityProjects.length > 1) {
      // Plusieurs projets dans la même ville
      const cityName = project.adresseClient?.split(',')[0]?.trim() || 'Ville inconnue';
      return `Projet ${index + 1} - ${cityName}`;
    } else {
      // Projet unique dans la ville - afficher l'adresse complète (tronquée si trop longue)
      const address = project.adresseClient || 'Adresse non spécifiée';
      return address.length > 50 ? address.substring(0, 47) + '...' : address;
    }
  };

  // Fonction de navigation vers un projet
  const handleProjectClick = (projectId) => {
    console.log("🔄 MULTI-DASHBOARD: Navigation vers projet:", projectId);
    navigate(`/client/${projectId}`);
  };

  // Affichage de chargement
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mx-auto mb-4"></div>
          <p className="text-gray-600">Chargement de vos projets...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-green-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Header */}
        <div className="bg-white shadow-sm rounded-lg mb-8">
          <div className="px-6 py-4 flex items-center justify-between">
            <div>
              <h1 className="text-2xl font-bold text-gray-900">EnergeSync</h1>
              <p className="text-sm text-gray-600">{user?.email}</p> {/* CORRIGÉ: user au lieu de currentUser */}
            </div>
            <button
              onClick={handleLogout}
              className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 transition-colors duration-200"
            >
              Déconnexion
            </button>
          </div>
        </div>

        {/* Titre principal */}
        <div className="text-center mb-8">
          <h2 className="text-3xl font-bold text-gray-900 mb-2">
            Vos Projets EnergeSync
          </h2>
          <p className="text-gray-600">
            Vous avez {userProjects.length} projet{userProjects.length > 1 ? 's' : ''} • Sélectionnez un projet pour accéder à votre tableau de bord
          </p>
        </div>

        {/* Grille des projets */}
        {userProjects.length > 0 ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {userProjects.map((project, index) => {
              const displayName = getProjectDisplayName(project, index);
              const progressPercent = project.progressGlobal || 0;

              return (
                <div
                  key={project.id}
                  onClick={() => handleProjectClick(project.id)}
                  className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 cursor-pointer transform hover:scale-105 border border-gray-200 group"
                >
                  {/* Header de la carte */}
                  <div className="p-6 border-b border-gray-100">
                    <div className="flex items-center justify-between mb-3">
                      <h3 className="text-xl font-semibold text-gray-900 truncate group-hover:text-blue-600 transition-colors duration-200">
                        {project.titre || project.title || 'Projet sans nom'}
                      </h3>
                      <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                        {project.typeClient || 'Type non défini'}
                      </span>
                    </div>
                    
                    <p className="text-gray-600 text-sm font-medium mb-2 flex items-center">
                      📍 {displayName}
                    </p>
                    
                    <div className="flex items-center justify-between text-sm text-gray-500">
                      <span className="flex items-center">
                        ⚡ {project.raccordement || 'Raccordement non défini'}
                      </span>
                      <span className="flex items-center">
                        🔌 {project.puissanceInstallation || 'Non définie'}
                      </span>
                    </div>
                  </div>

                  {/* Contenu de la carte */}
                  <div className="p-6">
                    {/* Barre de progression */}
                    <div className="mb-4">
                      <div className="flex items-center justify-between mb-2">
                        <span className="text-sm font-medium text-gray-700">Avancement du projet</span>
                        <span className="text-sm font-bold text-gray-900">{progressPercent}%</span>
                      </div>
                      <div className="w-full bg-gray-200 rounded-full h-3">
                        <div
                          className="bg-gradient-to-r from-blue-500 to-green-500 h-3 rounded-full transition-all duration-500 ease-out"
                          style={{ width: `${progressPercent}%` }}
                        ></div>
                      </div>
                    </div>

                    {/* Statut */}
                    <div className="flex items-center justify-between mb-4">
                      <div className="flex items-center">
                        <div className={`w-3 h-3 rounded-full mr-2 ${
                          project.statut === 'terminé' ? 'bg-green-500' :
                          project.statut === 'en cours' ? 'bg-yellow-500' :
                          'bg-gray-400'
                        }`}></div>
                        <span className="text-sm text-gray-600 capitalize font-medium">
                          {project.statut || 'À démarrer'}
                        </span>
                      </div>
                      
                      <div className="text-xs text-gray-400">
                        {project.createdAt?.toDate?.()?.toLocaleDateString('fr-FR') || 'Date inconnue'}
                      </div>
                    </div>

                    {/* Informations supplémentaires */}
                    {project.description && (
                      <div className="mt-3 pt-3 border-t border-gray-100">
                        <p className="text-sm text-gray-600 leading-relaxed">
                          {project.description.length > 100 
                            ? project.description.substring(0, 100) + '...' 
                            : project.description}
                        </p>
                      </div>
                    )}
                  </div>

                  {/* Footer avec bouton d'action */}
                  <div className="px-6 pb-6">
                    <button className="w-full bg-gradient-to-r from-blue-500 to-green-500 text-white py-3 px-4 rounded-lg hover:from-blue-600 hover:to-green-600 transition-all duration-300 font-medium text-sm group-hover:shadow-lg">
                      Accéder au tableau de bord →
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          <div className="text-center py-16">
            <div className="bg-white rounded-lg shadow-lg p-12 max-w-md mx-auto">
              <div className="text-gray-400 text-7xl mb-6">📋</div>
              <h3 className="text-xl font-medium text-gray-900 mb-3">Aucun projet trouvé</h3>
              <p className="text-gray-500 mb-6">
                Vos projets EnergeSync apparaîtront ici une fois qu'ils auront été créés par votre équipe.
              </p>
              <button
                onClick={() => window.location.reload()}
                className="inline-flex items-center px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 transition-colors duration-200"
              >
                🔄 Actualiser
              </button>
            </div>
          </div>
        )}

        {/* Footer informatif */}
        {userProjects.length > 0 && (
          <div className="mt-12 text-center">
            <p className="text-sm text-gray-500">
              💡 Cliquez sur une carte pour accéder au tableau de bord détaillé de votre projet
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default MultiDashboardClient;